import React, {useContext, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import IosHint from './iosHint';
import {WebAppInstallPromptContext} from './context';

function InstallWebAppPrompt() {
	const {capturedPrompt, dismissPrompt} = useContext(
		WebAppInstallPromptContext
	);

	if (
		!capturedPrompt ||
		capturedPrompt.type !== 'iOS' ||
		capturedPrompt.isDismissed
	)
		return null;

	return (
		<>
			<IosHint onClose={dismissPrompt} />
			<RouterAware onRouteChange={dismissPrompt} />
		</>
	);
}

function RouterAware({onRouteChange}) {
	const location = useLocation();
	const isFirstRun = useRef(true);

	useEffect(() => {
		if (isFirstRun.current) {
			isFirstRun.current = false;
			return;
		}

		onRouteChange();
	}, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

	return null;
}

export default InstallWebAppPrompt;
